import React from 'react';
import ArticleCardBase from '../../Base';

import './styles.scss';

const SquareQuote2 = ({ data, endCard }) => {
  const { backgroundColor, articleAsset1, paragraphC23, dashColor, personName } = data;

  return (
    <ArticleCardBase variation="square" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container square-quote-2">
        <img alt="Quote" src={articleAsset1[0].url} className="square-quote-2__quote-sign" />
        <div className="square-quote-2__quote-wrapper">
          <div
            className="square-quote-2__quote-text"
            dangerouslySetInnerHTML={{ __html: paragraphC23 }}
          />
          <div
            className="square-quote-2__person-name"
            dangerouslySetInnerHTML={{
              __html: `<span class="square-quote-2__person-name__dash" style="color: ${dashColor}"></span> ${personName}`
            }}
          />
        </div>
      </section>
    </ArticleCardBase>
  );
};

export default SquareQuote2;
